export default function TrustBarSection() {
  const items = [
    { icon: 'ri-map-pin-2-line', label: 'Serving agencies across Ontario' },
    { icon: 'ri-time-line', label: '24-hour response to placement inquiries' },
    { icon: 'ri-file-list-3-line', label: 'Individualized care plans' },
    { icon: 'ri-chat-1-line', label: 'Collaborative communication' },
    { icon: 'ri-heart-line', label: 'Relationship-based care' },
    { icon: 'ri-lightbulb-line', label: 'Evidence-informed practices' },
  ];

  return (
    <section className="bg-background-100 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-7">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-3">
          {items.map((item, idx) => (
            <div
              key={item.label}
              className="flex items-center gap-3 animate-trust-stagger"
              style={{ animationDelay: `${0.1 + idx * 0.08}s` }}
            >
              <span className="w-9 h-9 flex items-center justify-center bg-accent-100 text-accent-700 rounded-lg flex-shrink-0">
                <i className={`${item.icon} text-sm`}></i>
              </span>
              <span className="text-foreground-700 text-xs md:text-sm font-medium label-font leading-snug">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}